import request from '@/utils/analyticsRequest'

export function getGhlStatus() {
  return request({ url: '/api/v1/crm/oauth/status', method: 'get' })
}

export function listGhlLocations() {
  return request({ url: '/api/v1/ghl/locations/mine', method: 'get' })
}

export function provisionGhlLocation(data) {
  return request({
    url: '/api/v1/ghl/locations/provision',
    method: 'post',
    data,
    timeout: 30000
  })
}

export function subscribeGhlPlan(data) {
  return request({
    url: '/api/v1/ghl/subscriptions/subscribe',
    method: 'post',
    data,
    timeout: 30000
  })
}
